export default {
    intro: 'Start the trend evaluation',
    description: 'Create a new trend radar and define for which area the trend evaluation is relevant.<br />This could be:',

    options: {
        company: 'a business unit',
        product: 'a product line',
        function: 'a function in your company such as marketing or research & development'
    }
}
